import { render, staticRenderFns } from "./bStore_setup.vue?vue&type=template&id=f541bd4c&scoped=true"
import script from "./bStore_setup.vue?vue&type=script&lang=js"
export * from "./bStore_setup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f541bd4c",
  null
  
)

export default component.exports